var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',{attrs:{"variant":"danger","icon":_vm.ciExclamationCircle}},[_vm._v("\n  "+_vm._s(_vm.$t('damaged'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }